import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className={`dark-header ${scrolled ? 'scrolled' : ''}`}>
      <Link to="/" className="logo-container">
        <img src="/logo.jpg" alt="Infinity Capital Inc." className="logo-image" />
      </Link>
      
      <nav className="dark-nav">
        <button onClick={() => scrollToSection('services')} className="dark-nav-link">
          Services
        </button>
        <button onClick={() => scrollToSection('about')} className="dark-nav-link">
          About
        </button>
        <button onClick={() => scrollToSection('testimonials')} className="dark-nav-link">
          Testimonials
        </button>
        <button onClick={() => scrollToSection('faq')} className="dark-nav-link">
          FAQ
        </button>
        <button onClick={() => scrollToSection('contact')} className="btn-primary btn-small">
          Schedule Consultation
        </button>
      </nav>
    </header>
  );
};

export default Header;
